<ng-container
  ><div class="flex flex-col items-center justify-center">
    <div class="flex flex-col items-center text-center">
      <div class="mb-4">
        <span class="text-3xl">{{ errorIcon() }}</span>
      </div>
      <div class="mb-4">
        <span class="text-base font-normal text-gray-600">
          {{ errorName() }}
        </span>
      </div>
      <div
        class="rounded-lg border border-blue-500 bg-blue-50 p-2 text-blue-700"
      >
        <p class="text-base text-gray-600">{{ errorMessage() }}</p>
      </div>
    </div>
  </div></ng-container
>
